module.exports = __webpack_public_path__ + "static/media/DTN Network - GBR Tech - 23-04-2024 N.32a7739e.gif";